import { Box } from "@mui/material";
import ChatFlutuant from "../../components/ChatFlutuant";
import MenuLateral from "../../components/MenuLateral";
import Header from "../../components/header";
import ListagemDevolucoes from "../../components/listagemdevolucao";
import HeaderMobile from "../../components/headerMobile";

export default function Devolution() {
  return (
    <>
      {/* desktop */}
      <Box display={{ xs: "none", md: "initial" }}>
        <Header />
        <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={5}>
          <MenuLateral currentPage="devolution" />
          <Box width={"100%"} ml={2}>
            <ListagemDevolucoes />
          </Box>
        </Box>
      </Box>
      {/* desktop */}

      {/* Mobile */}
      <Box display={{ xs: "initial", md: "none" }}>
        <HeaderMobile currentPage="devolution" />
        <ListagemDevolucoes />
      </Box>
      {/* Mobile */}

      <ChatFlutuant />
    </>
  );
}
